import { loadEnvConfig, readAccessibilityRemoteUrl } from '../services/envConfig';
import { getStaticBaseUrl } from '../utils/publicUrl';
import { loadRemoteModule } from './loadRemoteModule';
import { portalAccessibilityTheme } from './portalAccessibilityTheme';
/** Container global and exposed key, both fixed by the remote's own webpack config. */
const REMOTE_GLOBAL = 'delasoftAccessibility';
const REMOTE_MODULE = './widget';
/**
 * Absolute URLs (a CDN, another host) pass through; anything else resolves against
 * this app's own base so a copy served from `public/` still works when the portal
 * is hosted under an IIS virtual directory (e.g. `/OneStop/`) rather than at the
 * domain root.
 */
function resolveRemoteUrl(configured) {
    if (/^(https?:)?\/\//i.test(configured))
        return configured;
    return `${getStaticBaseUrl().replace(/\/?$/, '/')}${configured.replace(/^\//, '')}`;
}
/**
 * No-ops (logging why) when `AccessibilityRemoteUrl` isn't configured for this
 * environment, and never throws — the portal must render regardless of whether
 * the widget is available.
 */
export function mountAccessibilityWidget() {
    void loadEnvConfig().then((env) => {
        const configured = readAccessibilityRemoteUrl(env);
        if (!configured) {
            console.info('[a11y] AccessibilityRemoteUrl not configured in env.json — accessibility widget not mounted.');
            return;
        }
        void loadRemoteModule({
            url: resolveRemoteUrl(configured),
            globalName: REMOTE_GLOBAL,
            module: REMOTE_MODULE,
        })
            .then((widget) => {
            try {
                widget.mount({ theme: portalAccessibilityTheme });
            }
            catch (err) {
                /* A theme that fails the widget's WCAG audit throws here — fall back to its own default theme. */
                console.error('[a11y] Portal theme rejected by the accessibility widget; using its default.', err);
                widget.mount();
            }
        })
            .catch((err) => {
            console.error('[a11y] Accessibility widget unavailable.', err);
        });
    });
}
